module.exports = __webpack_public_path__ + "static/Pr-9ae20ab8ddfc119e2d75e3efe59e0ef9.png";